import { createActionGroup, props } from '@ngrx/store';

export type PersistedKey = { key: string[]; sections: string[] };

export const hydrationActions = createActionGroup({
  source: 'Hydration',
  events: {
    Hydrate: props<{ persistedKeys: PersistedKey[] }>(),
    'Hydrate Success': props<{ element: PersistedKey; newState: object; userId?: string }>(),
    'Hydrate Fail': props<{ element: PersistedKey; userId?: string }>(),
    Watch: props<{ element: PersistedKey; userId?: string }>(),
  },
});
